/**
 * Shell auth hook — adapts BeHeard's auth hooks to the SuiteShellAdapter.AuthHookResult interface.
 */

import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectIsCentralAuthenticated } from '../../store/slices/centralAuthSlice';
import { useWorkspace } from '../../hooks/useWorkspace';

export function useShellAuth() {
  const isAuthenticated = useSelector(selectIsCentralAuthenticated);
  const { switchWorkspace } = useWorkspace();

  const handleSwitchWorkspace = useCallback(
    async (workspaceId: string) => {
      await switchWorkspace(workspaceId);
    },
    [switchWorkspace]
  );

  return {
    authSource: isAuthenticated ? ('central' as const) : null,
    switchWorkspace: handleSwitchWorkspace,
  };
}
